module.exports = __webpack_public_path__ + "static/filmtalents_home-eab4db2d4a545e8dc1dad88dee839c47.jpg";